/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import {
  DATE_MONTH_VIEW_FORMAT,
  checkValidMobileNumber,
} from '../../../shared/constants/Constants';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import { getUserDetails } from '../../../api/profileApi';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import BusShareCard from './BusShareCard';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';

function BusWhatsAppShareModal({
  onClearWhatsApp,
  busOptionsToShare,
  searchRequest,
}) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [showBreakup, setShowBreakup] = useState(true);
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [countryCode, setCountryCode] = useState('91');

  const getUserData = async () => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      setUserDetails(User);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };

  const handleSendWhatsapp = () => {
    if (
      whatsappNumber === '' ||
      whatsappNumber === undefined ||
      checkValidMobileNumber(whatsappNumber)
    ) {
      setValidationError(true);
      return false;
    }
    setIsLoading(true);
    let fromEmail = '';
    let contactNum = '';
    // let companyName = '';
    if (!isEmpty(userDetails)) {
      fromEmail = userDetails.ContactEmail;
      contactNum = userDetails.ContactNumber;
      // companyName = userDetails.Company;
    }
    let msg = '';
    msg += `Buses from ${searchRequest.origin.place_name} to ${
      searchRequest.destination.place_name
    } | ${formatDate(
      getNewDate(searchRequest.jdate),
      DATE_MONTH_VIEW_FORMAT,
    )}\n\n`;
    busOptionsToShare.forEach((bus) => {
      msg += `${bus.operatorname} \n${bus.bustype}\n ${
        showBreakup
          ? `Starting from: ${appConfig?.appCurrency} ${getAmount(
              bus.supplierfares[0]?.totalnet,
            )}`
          : ''
      }  \n\n `;
    });
    msg += `\n\nThank you for choosing Fastays\nIn case of any urgent support : \n`;
    msg += ` Contact : ${contactNum}\n Email  : ${fromEmail}\n`;
    const encodedMessage = encodeURIComponent(msg);
    const whatsAppUrl = `https://wa.me/${countryCode}${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsAppUrl, '_blank');
    onClearWhatsApp();
    setIsLoading(false);
  };
  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div className="d-flex align-items-center gap-3 mb-1">
        <AppRadioInput
          id="true"
          name="showBrakup"
          labelText="With Fare"
          value=""
          onChange={() => setShowBreakup(true)}
          checked={showBreakup}
        />
        <AppRadioInput
          id="false"
          name="showBrakup"
          labelText="Without Fare"
          value=""
          onChange={() => setShowBreakup(false)}
          checked={!showBreakup}
        />
      </div>
      <Row className="spacing-16 my-2">
        <Col lg={2} md={2} sm={6} xs={12}>
          <AppTextInput
            name="countryCode"
            label="Country Code"
            value={countryCode}
            type="text"
            maxLength={2}
            pattern="[0-9]{1,2}"
            onChange={(d) => setCountryCode(d.target.value)}
          />
        </Col>
        <Col lg={6} md={6} sm={6} xs={12}>
          <AppNumberInput
            label="WhatsApp Number"
            name="whatsappNumber"
            placeholderText=""
            required
            value={whatsappNumber}
            onChange={(d) => setWhatsappNumber(d)}
            errorText={validationError && 'Please Enter Mobile Number'}
          />
          {checkValidMobileNumber(whatsappNumber) && validationError && (
            <small className="app-error-text">Enter Valid Number</small>
          )}
        </Col>
        {getValueFromAppConfig('ISCORPORATECLIENT') !== 'true' && (
          <Col lg={4} md={4} sm={6} xs={12}>
            <AppNumberInput
              name="markUpToBeAdded"
              label="Markup"
              value={markUpToBeAdded}
              onChange={(d) => setMarkupToBeAdded(d)}
            />
          </Col>
        )}
        <Col lg={12} md={12} sm={12} xs={12} className="hide-in-mobile">
          <div className="overflow-auto">
            <BusShareCard
              busOptionsToShare={busOptionsToShare}
              searchRequest={searchRequest}
              showInput
              showBreakup={showBreakup}
              markUpToBeAdded={markUpToBeAdded}
            />
          </div>
        </Col>
        <Col
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="d-flex justify-content-end"
        >
          <div>
            <AppButton
              btnText="Send WhatsApp"
              onClick={handleSendWhatsapp}
              variant="primary"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

BusWhatsAppShareModal.propTypes = {
  onClearWhatsApp: PropTypes.func.isRequired,
  busOptionsToShare: PropTypes.array.isRequired,
  searchRequest: PropTypes.object.isRequired,
};

export default BusWhatsAppShareModal;
